<template>
    <span :class="{'disabled-buttons': disabled }">
        <button v-if="type == 1" @click="addToCart()" class="product-actions__buy-btn btn" type="button" :disabled="!allowRequest">
            <span v-if="item.remains_count > 0">
                {{ trans('product.buy') }}
            </span>
            <span v-else>
                {{ trans('product.not_exists') }}
            </span>
            <svg v-if="!allowRequest && !addedSuccess" class="icon" style="fill: white">
                <use xlink:href="/img/front/icons/svgmap.svg#clock"/>
            </svg>
            <svg v-if="addedSuccess" class="icon" style="fill: white">
                <use xlink:href="/img/front/icons/svgmap.svg#check"/>
            </svg>
        </button>

        <button v-if="type == 2" @click="addToCart()" type="button" class="btn-round-large">
            <svg v-if="!addedSuccess && allowRequest" class="icon">
                <use xlink:href="/img/front/icons/svgmap.svg#add"/>
            </svg>
            <svg v-if="!allowRequest && !addedSuccess" class="icon">
                <use xlink:href="/img/front/icons/svgmap.svg#clock"/>
            </svg>
            <svg v-if="addedSuccess" class="icon">
                <use xlink:href="/img/front/icons/svgmap.svg#check"/>
            </svg>
        </button>

        <button v-if="type == 3" @click="addToCart()" type="button" class="btn-outlined-sm">
            <svg class="icon">
                <use xlink:href="/img/front/icons/svgmap.svg#add" />
            </svg>
            <span class="text">
                {{ trans('product.add') }}
            </span>
        </button>

        <button v-if="type == 4" class="product-actions__buy-btn btn" type="button">
            <span class="text">
                {{ trans('product.select_size') }}
            </span>
        </button>

        <!--{{ $store.state.cart }}-->
    </span>
</template>

<script>
import axios from "axios";

import helper from "./../mixins/helper";
import ProductAdd from "./../analytics/ProductAdd";

export default {
    mixins: [helper, ProductAdd],
    components: {
        
    },
    props: {
        translations:{
            required: true
        },
        item: {
            required: true
        },
        type: {
            required: true
        }
    },
    data() {
        return {
            allowRequest: true,
            addedSuccess: false,
            waiting: true
        }
    },
    computed: {
        disabled() {
            if (this.remaining > 0) { // this.item.type !== 'variety'
                return false;
            } else {
                return true;
            }
        },
        remaining() {
            let count = 0;
            this.item.remaining.forEach(element => {
                if (element.warehouse.available_to_buy) {
                    count = count + element.quantity;
                }
            });
            let incart_element;
            if (this.isset(this.$store.state.cart.data)) {
                incart_element = this.$store.state.cart.data.filter(obj => obj.product == this.item.id)[0];
            }
            let count_in_cart = 0;
            if (this.isset(incart_element)) {
                count_in_cart = incart_element.count;
            }
            if (count > 0 && count > count_in_cart) {
                return true;
            } else {
                return false;
            }
        }
    },
    beforeMount() {
    },
    mounted() {
        setTimeout(() => {
            this.waiting = false;
        }, 500);
    },
    methods: {
        checkExistInCart() {
            return true;
        },
        allow() {
            setTimeout(()=>{
                this.allowRequest = true;
            }, 1000);
        },
        addedDisable() {
            this.addedSuccess = true;
            setTimeout(()=>{
                this.addedSuccess = false;
            }, 1000);
        },
        addToCart() {
            if (this.item.type == 'variety') {
                window.location.href = this.item.slug_suffix;
            } else if (this.allowRequest && window.allowNextRequest && this.remaining && !this.waiting) {

                // Группа для задание лоадера на текущей кнопке, глобального в нижме прамо углу и запрета на добавление других товаров до окончания запроса
                window.allowNextRequest = false;
                this.allowRequest = false;
                this.$store.commit('cart_saving', true);

                // 1. Считываем куки (метод для расшифровки laravel)
                // 2. Если куков нет, то создаем, устанавливаем и сохраняем добавленный продукт в корзину в базу с привязкой к кукам по ID
                // 3. Если есть куки, то берем их id и обновляем корзину
                this.getCookie('cart', (response) => {
                    if (response.data.data == null) {
                        this.saveInDataBase(null);
                    } else {
                        this.saveInDataBase(JSON.parse(response.data.data).id);
                    }
                });
            }

            // Analytics by mixin ProductAdd
            if (this.type == 1) {
                this.pushDataSingle(this.item);
            } else {
                this.pushDataListing(this.item);
            }
            this.pushDataAddToCart(this.item);
        },
        saveInDataBase(id) {
            let cartObj = {
                id: id,
                data: this.saveInVueStore().data
            };

            console.log(cartObj);
            if (cartObj) {
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/update_cart",
                    data: {
                        cart: cartObj
                    },
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    this.$store.commit('cart_add', response.data[0]);
                    // Show notifictation
                    this.$store.commit('new_good_added', 0);

                    // Группа для отмены лоадера на текущей кнопке, глобального в нижме прамо углу и запрета на добавление других товаров до окончания запроса
                    this.addedDisable();
                    this.allow();
                    setTimeout(()=>{
                        window.allowNextRequest = true;
                    }, 500);
                    this.$store.commit('cart_saving', false);

                    document.querySelector('.btn-cart.open-cart').click();

                    console.log(response.data[0].id);
                    let cookies = { 'id' : response.data[0].id, 'update_date' : Date.now() };
                    this.setCookie('cart', JSON.stringify(cookies), 7);
                })
                .catch(error => {
                    console.log(error);
                });
            }
        },
        saveInVueStore() {
            // Show notification on cart
            this.$store.commit('new_good_added', 1);
            let cart = this.$store.state.cart;
            let element_exist = false;
            // Check if element allready exist — update that
            if (this.isset(cart.data)) {
                cart.data.forEach(element => {
                    if (element.product == this.item.id) {
                        element.count++;
                        element_exist = true;
                    }
                });
            }
            if (!element_exist) {
                cart.data.push({ 'product': this.item.id, 'count': 1 });
            }
            // Save
            this.$store.commit('cart_add', cart);
            return this.$store.state.cart;
        }
    }
}
</script>
